import { useState, useEffect } from 'react';

interface UserBehavior {
  hasStartedForm: boolean;
  hasCompletedForm: boolean;
  timeOnSite: number;
  pageScrollDepth: number;
  hasVisitedBlog: boolean;
}

export const useUserBehavior = () => {
  const [behavior, setBehavior] = useState<UserBehavior>({
    hasStartedForm: false,
    hasCompletedForm: false,
    timeOnSite: 0,
    pageScrollDepth: 0,
    hasVisitedBlog: false
  });

  // Track time on site
  useEffect(() => {
    const interval = setInterval(() => {
      setBehavior(prev => ({
        ...prev,
        timeOnSite: prev.timeOnSite + 1
      }));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  // Track scroll depth
  useEffect(() => {
    const handleScroll = () => {
      const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrolled = (window.scrollY / scrollHeight) * 100;
      
      setBehavior(prev => ({
        ...prev,
        pageScrollDepth: Math.max(prev.pageScrollDepth, Math.round(scrolled))
      }));
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Update behavior
  const updateBehavior = (update: Partial<UserBehavior>) => {
    setBehavior(prev => ({
      ...prev,
      ...update
    }));
  };

  return {
    behavior,
    updateBehavior
  };
};